<template>
  <div class="pGAddress">
    <div v-for="(item, j) in prescriptions" :key="j" class="pGAItem pDivBorder">
      <div id="pFont">
        <PDiv>
          <PCH>
            {{ item.PatientName }}&nbsp;&nbsp;/&nbsp;&nbsp;{{ item.PatientId }}
          </PCH>
        </PDiv>
        <PDiv>
          <PCH> C/O:&nbsp;&nbsp;{{ item.DocName }} </PCH>
        </PDiv>
        <PDiv>
          <PCH>
            {{ item.DocAddress }}
          </PCH>
        </PDiv>
        <PDiv>
          <PCH> Mobile:&ensp;{{ item.DocMobile }} </PCH>
        </PDiv>
      </div>
    </div>
  </div>
</template>

<script>
import PDiv from "../../components/print/PDiv";
import PCH from "../../components/print/PContentHeading";
export default {
  components: {
    PCH,
    PDiv
  },
  props: {
    prescriptions: {
      type: Array,
      default: () => {
        return [];
      }
    }
  }
};
</script>

<style scoped></style>
